import React from 'react'
import yellowAlert from "src/assets/images/yellow-alert.png";

const AlertContentWithFlag = (props) => {
    const { message, type, callBackFunc } = props;
    const isDisplay = props.isDisplay === false ? false : true;
    const isDisplayIcon = props.isDisplayIcon === false ? false : true;

    // Bug : 17462 - On Close Alert Callback function implement to reset redux flag - 05 Mar 2024 - PN
    const onClose = (e) => {
        if(callBackFunc && typeof callBackFunc === 'function'){
            callBackFunc();
        }
        else
        {
            e.preventDefault();
            return false;
        }
    }
    return (
        <>
            <div className={props.addUsercontainer ?'container-fluid' : 'container'}>
                <div className="row">
                    <div className="col-lg-12 p-0">
                        {message !== null && message !== undefined &&
                            <div className={'alert alert-' + type} role="alert">
                                <span className='w-100 bs5 d-block'><div className="text-break" dangerouslySetInnerHTML={{ __html: message }} /></span>
                                {isDisplay &&
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={(e) => callBackFunc && onClose()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                }
                                {
                                    isDisplayIcon &&
                                    <img src={yellowAlert} />
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AlertContentWithFlag